import * as AUTH_ACTION_TYPES from './constants.js';

const initialState = {
    token: '',
    user: null,
};

const auth = (state = initialState, {
    type,
    payload,
}) => {
    switch (type) {
        case AUTH_ACTION_TYPES.AUTH_SUCCESS:
            return {
                ...state,
                user: payload,
            };

        case AUTH_ACTION_TYPES.AUTH_ERROR:
            return {
                ...state,
                user: null,
                token: '',
            };

        case AUTH_ACTION_TYPES.SET_TOKEN:
            return {
                ...state,
                token: payload,
            };

        default:
            return state;
    }
};

export default auth;



// WEBPACK FOOTER //
// ./app/web/src/container/LoginPage/reducer.js